module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', [_vm._v(_vm._s(_vm.property.name))]), _vm._v(" = " + _vm._s(_vm.value.value_varchar) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-172394d1","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shop/Product/ProductPropertyRow.vue
// module id = 48
// module chunks = 0